const typographyFormActions = {
  true: 'Gerar Nova Ação',
  false: 'Editar Ação',
  file: 'ANEXAR ARQUIVOS'
};

export default typographyFormActions;
